import { BUSINESS } from "@/data/site";

const items = [
  "Free estimates & quotes",
  "Same-day & next-day service",
  "Licensed & insured in Louisiana",
  "All major appliance brands",
  "Courier · medical · freight",
  "TV mount · power wash · paint",
  `Family-owned · ${BUSINESS.yearsExperience} years experience`,
  "New Orleans → Baton Rouge",
];

export const Marquee = () => {
  const doubled = [...items, ...items];
  return (
    <div
      data-testid="brand-marquee"
      className="border-y border-[var(--ji-border)] overflow-hidden bg-[var(--ji-surface)]"
    >
      <div className="ji-marquee-track py-4">
        {doubled.map((t, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-4 px-6 text-sm uppercase tracking-[0.2em] text-[var(--ji-muted)]"
          >
            {t}
            <span className="text-[var(--ji-accent)]">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};
